import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../../../components/Hooks/axios";
import Modal from "../../../../components/Modal/Modal";
import classes from "../Update Name/UpdateName.module.css";
import Verification from "../Verification/Verification";
import { setUserObject } from "../../../../redux/slices/authSlice";
import { toast } from "react-toastify";
import close from '../../../../assets/images/close.png'
import { EmailValidate } from "../../../../components/Hooks/EmailValidate";

const UpdateEmail = ({ onClose, email }) => {
	const { userId } = useSelector((state) => state.auth);
	const [verification, setVerification] = useState(false);
	const dispatch = useDispatch();
	const [btnDisable, setBtnDisable] = useState(false);
	const [content, setContent] = useState(email);

	const handelUpdateName = () => {
		if (content === "") return toast.warn("Please fill the filed !");
		if (EmailValidate(content)) return toast.error("Invalid Email !");
		setBtnDisable(true);

		const data = JSON.stringify({
			email: content,
		});

		axios
			.put(`/auth/update-user-details?userId=${userId}`, data, {
				headers: {
					"Content-Type": "application/json",
				},
			})
			.then(({ data }) => {
				toast.success(data.message);
				dispatch(setUserObject(data.user));
				setBtnDisable(false);
				onClose(false);
			})
			.catch((response) => {
				console.log(response);
				setBtnDisable(false);
			});
	};

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1024);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<Modal onClose={onClose}>
			{verification && <Verification onClose={setVerification} />}
			<div className={classes.overlay} onClick={(e) => e.stopPropagation()}>
				<div className={classes.form}>
					<h2>
						Update Email
						{!isMobile &&
							<div className={classes.BackButton}>
								<img src={close} alt="" onClick={onClose} />
							</div>
						}
					</h2>
					<p>Please enter your new email id which you want to update and use</p>
					<label htmlFor="email">New Email</label>
					<input
						type="email"
						placeholder="Enter your email id"
						value={content}
						onChange={(e) => setContent(e.target.value)}
					/>
					<div className={classes.actions}>
						<button className={classes.btn} disabled={btnDisable} onClick={handelUpdateName}>
							Update
						</button>
						<button className={classes.link} onClick={() => onClose(false)}>
							Back
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default UpdateEmail;


